import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Chart from 'chart.js';

class VesselPositionsChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chart: {},
        };
    }

    componentDidMount() {
        this.createRangeDates(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.createRangeDates(nextProps);
    }

    createRangeDates(props) {
        let { chart } = this.state;
        const { statistics } = props;

        const labels = [];
        const requests = [];
        const onRoute = [];
        const totalVessels = [];

        statistics.forEach((request) => {
            labels.push(moment.utc(request.date).format('MM-DD-YYYY'));
            requests.push(request.quantity);
            onRoute.push(request.onRoute | 0);
            totalVessels.push(request.totalVessels | 0);
        });

        const datasets = [
            {
                name: 'Total Vessels',
                type: 'line',
                data: totalVessels,
                yAxisIndex: 1,
                stack: 'Total Vessels',
                label: 'Total Vessels',
                symbolSize: 6,
                lineStyle: {
                    width: 2,
                },
                borderColor: '#22d661',
            },
            {
                label: 'Real',
                backgroundColor: 'blue',
                borderColor: 'blue',
                data: requests,
            }, 
            {
                label: 'On route',
                backgroundColor: 'pink',
                borderColor: 'pink',
                data: onRoute,
            },
        ];

        if (_.isEmpty(chart)) {
            chart = this.createChart(labels, datasets);
        } else {
            chart = this.updateChart(chart, labels, datasets);
        }

        this.setState({
            chart,
        });
    }

    updateChart(chart, labels, datasets) {
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        chart.update(0);

        return chart;
    }

    createChart(labels, datasets) {
        const ctx = this.refs.chart.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets,
            },
            options: {
                tooltips: {
                    mode: 'label',
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true,
                    }],
                },
            },
        });

        return chart;
    }

    render() {
        return (
            <canvas ref='chart' />
        );
    }
}

export default connect(
    ({ statisticsVesselPositions: { items } }, { from, until }) => ({
        statistics: items,
        from,
        until,
    }),
    dispatch => bindActionCreators({

    }, dispatch),
)(VesselPositionsChart);



// WEBPACK FOOTER //
// ./app/components/Statistics/Monitor/VesselPositionsChart.jsx